export const getInitStorageValue = <T>(key: string): T | undefined => {
  const value = sessionStorage.getItem(key);
  if (!value) return undefined;

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as T;
  }
};
